import instance from "../axios";
import ls from "local-storage";

export const getAll = async () => {
    const response = await instance.get("custom_payment_methods/GetAll.php?partnerID=" + ls.get('partnerID'));
    return response.data;
};